.step-get-to-know-container {
    max-width: 350px;
}

/* Mobile styles */
@media (max-width: 768px) {
    .step-get-to-know-container {
        max-width: unset;
    }
}
